<script setup lang="ts">
import { computed } from 'vue'
import { useRuntimeStore } from '../stores/runtime'
const store = useRuntimeStore()
const user = computed(() => store.currentUser)
const bitrix = computed(() => store.session?.context?.bitrix)
</script>
<template>
  <section>
    <div class="page-head"><div><h1>Личный кабинет</h1><p>Базовая информация текущего пользователя.</p></div></div>
    <div class="info-card">
      <dl>
        <dt>Пользователь</dt><dd>{{ [user?.name, user?.last_name].filter(Boolean).join(' ') || 'Не указано' }}</dd>
        <dt>Bitrix ID</dt><dd>{{ user?.id || '—' }}</dd>
        <dt>Портал</dt><dd>{{ bitrix?.domain || '—' }}</dd>
        <dt>Отделы</dt><dd>{{ user?.departments?.join(', ') || '—' }}</dd>
      </dl>
    </div>
  </section>
</template>
